"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeFilesToScannedProjects = void 0;
const dep_graph_1 = require("@snyk/dep-graph");
const Debug = require("debug");
const path = require("path");
const lockFileParser = require("snyk-nodejs-lockfile-parser");
const resolveDeps = require("snyk-resolve-deps");
const debug = Debug("snyk");
const node_modules_utils_1 = require("./node-modules-utils");
async function nodeFilesToScannedProjects(filePathToContent) {
    const scanResults = [];
    /**
     * TODO: Add support for Yarn workspaces!
     * https://github.com/snyk/nodejs-lockfile-parser/blob/af8ba81930e950156b539281ecf41c1bc63dacf4/test/lib/yarn-workflows.test.ts#L7-L17
     *
     * When building the ScanResult ensure the workspace is stored in scanResult.identity.args:
     * args: {
     *   rootWorkspace: <path-of-workspace>,
     * };
     */
    if (Object.keys(filePathToContent).length === 0) {
        return [];
    }
    const fileNamesGroupedByDirectory = (0, node_modules_utils_1.groupFilesByDirectory)(filePathToContent);
    const [manifestFilePairs, nodeProjects] = findProjectsAndManifests(fileNamesGroupedByDirectory);
    if (manifestFilePairs.length !== 0) {
        scanResults.push(...(await depGraphFromManifestFiles(filePathToContent, manifestFilePairs)));
    }
    if (nodeProjects.length !== 0) {
        scanResults.push(...(await depGraphFromNodeModules(filePathToContent, nodeProjects, fileNamesGroupedByDirectory)));
    }
    return scanResults;
}
exports.nodeFilesToScannedProjects = nodeFilesToScannedProjects;
async function depGraphFromNodeModules(filePathToContent, nodeProjects, fileNamesGroupedByDirectory) {
    const scanResults = [];
    for (const project of nodeProjects) {
        const { tempDir, tempProjectPath, manifestPath } = await (0, node_modules_utils_1.persistNodeModules)(project, filePathToContent, fileNamesGroupedByDirectory);
        if (!tempDir) {
            continue;
        }
        if (!tempProjectPath) {
            await (0, node_modules_utils_1.cleanupAppNodeModules)(tempDir);
            continue;
        }
        try {
            const pkgTree = await resolveDeps(tempProjectPath, {
                dev: false,
                noFromArrays: true,
            });
            if (pkgTree.numDependencies === 0) {
                await (0, node_modules_utils_1.cleanupAppNodeModules)(tempDir);
                continue;
            }
            const depGraph = await dep_graph_1.legacy.depTreeToGraph(pkgTree, pkgTree.type || "npm");
            scanResults.push({
                facts: [
                    {
                        type: "depGraph",
                        data: depGraph,
                    },
                    {
                        type: "testedFiles",
                        data: manifestPath
                            ? manifestPath
                            : path.join(project, "node_modules"),
                    },
                ],
                identity: {
                    type: depGraph.pkgManager.name,
                    targetFile: manifestPath
                        ? manifestPath
                        : path.join(project, "node_modules"),
                },
            });
        }
        catch (error) {
            debug(`An error occurred while analysing node_modules dir: ${error.message}`);
        }
        finally {
            await (0, node_modules_utils_1.cleanupAppNodeModules)(tempDir);
        }
    }
    return scanResults;
}
async function depGraphFromManifestFiles(filePathToContent, manifestFilePairs) {
    const scanResults = [];
    const shouldIncludeDevDependencies = false;
    const shouldBeStrictForManifestAndLockfileOutOfSync = false;
    for (const pathPair of manifestFilePairs) {
        // TODO: initially generate as DepGraph
        let parserResult;
        try {
            parserResult = await lockFileParser.buildDepTree(filePathToContent[pathPair.manifest], filePathToContent[pathPair.lock], shouldIncludeDevDependencies, pathPair.lockType, shouldBeStrictForManifestAndLockfileOutOfSync);
        }
        catch (err) {
            debug(`An error occurred while analysing a pair of manifest and lock files: ${err.message}`);
            continue;
        }
        const strippedLabelsParserResult = stripUndefinedLabels(parserResult);
        const depGraph = await dep_graph_1.legacy.depTreeToGraph(strippedLabelsParserResult, pathPair.lockType);
        const depGraphFact = {
            type: "depGraph",
            data: depGraph,
        };
        const testedFilesFact = {
            type: "testedFiles",
            data: [path.basename(pathPair.manifest), path.basename(pathPair.lock)],
        };
        scanResults.push({
            facts: [depGraphFact, testedFilesFact],
            identity: {
                type: depGraph.pkgManager.name,
                targetFile: pathPair.manifest,
            },
        });
    }
    return scanResults;
}
function findProjectsAndManifests(fileNamesGroupedByDirectory) {
    const manifestLockPathPairs = [];
    const nodeProjects = [];
    for (const directoryPath of fileNamesGroupedByDirectory.keys()) {
        const filesInDirectory = fileNamesGroupedByDirectory.get(directoryPath);
        if (!filesInDirectory || filesInDirectory.size < 1) {
            // missing manifest files
            continue;
        }
        const expectedManifest = path.join(directoryPath, "package.json");
        const expectedNpmLockFile = path.join(directoryPath, "package-lock.json");
        const expectedYarnLockFile = path.join(directoryPath, "yarn.lock");
        const hasManifestFile = filesInDirectory.has(expectedManifest);
        const hasLockFile = filesInDirectory.has(expectedNpmLockFile) ||
            filesInDirectory.has(expectedYarnLockFile);
        if (hasManifestFile && hasLockFile) {
            manifestLockPathPairs.push({
                manifest: expectedManifest,
                // TODO: correlate filtering action with expected lockfile types
                lock: filesInDirectory.has(expectedNpmLockFile)
                    ? expectedNpmLockFile
                    : expectedYarnLockFile,
                lockType: filesInDirectory.has(expectedNpmLockFile)
                    ? lockFileParser.LockfileType.npm
                    : lockFileParser.LockfileType.yarn,
            });
            continue;
        }
        nodeProjects.push(directoryPath);
    }
    return [manifestLockPathPairs, nodeProjects];
}
function stripUndefinedLabels(parserResult) {
    const optionalLabels = parserResult.labels;
    const mandatoryLabels = {};
    if (optionalLabels) {
        for (const currentLabelName of Object.keys(optionalLabels)) {
            if (optionalLabels[currentLabelName] !== undefined) {
                mandatoryLabels[currentLabelName] = optionalLabels[currentLabelName];
            }
        }
    }
    const parserResultWithProperLabels = Object.assign({}, parserResult, {
        labels: mandatoryLabels,
    });
    return parserResultWithProperLabels;
}
//# sourceMappingURL=node.js.map